export const SigningFlowType = {
    signIn: {
        name: 'login',
        eventName: 'Sign In'
    },
    signUp: {
        name: 'join',
        eventName: 'Sign Up'
    },
    socialSignUp: {
        eventName: 'Social Sign Up'
    },
    social: {
        name: 'social',
        eventName: 'Social'
    }
};
